import {
  Alert,
  AlertIcon,
  VStack,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Skeleton,
} from '@chakra-ui/react';
import React from 'react';

import { DrawerSkeletonHeader } from 'packages/dataPipeline/ui/uploads/DrawerHeader';

export const UploadDrawerShell = ({
  onClose,
  children,
}: {
  onClose: () => void;
  children: React.ReactNode;
}) => {
  return (
    <Drawer onClose={onClose} isOpen size="xl" closeOnOverlayClick>
      <DrawerOverlay />
      <DrawerContent p={0}>{children}</DrawerContent>
    </Drawer>
  );
};

export const UploadDrawerSkeletonContent = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  return (
    <>
      <DrawerSkeletonHeader onClose={onClose} />
      <DrawerBody>
        <VStack spacing="20px" alignItems="flex-start">
          <Skeleton height="600px" width="100%" />
        </VStack>
      </DrawerBody>
    </>
  );
};

// a drawer that cannot show uploads, and why.
export const UploadDrawerMessageContent = ({
  onClose,
  message,
}: {
  onClose: () => void;
  message: string;
}): React.ReactElement => {
  return (
    <>
      <DrawerSkeletonHeader onClose={onClose} />
      <DrawerBody>
        <Alert status="warning">
          <AlertIcon />
          {message}
        </Alert>
      </DrawerBody>
    </>
  );
};
